import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"

class BookingButtonPresenterRoomTypeOrder extends React.Component {
  
  constructor(props) {
    super(props)
  }
   
  render() {

    var tabClasses = clsx ({
      'active': this.props.active_tab == 'room_type_order',
      'tab-pane': true 
    })

    return (
      <div className={tabClasses} id='room_type_order'>
        <div className="row select-all-none" style={{ marginBottom: -5 }}>
          <div className="col-md-12">
            <div className="toggle">
              {I18n.t("room_types")}
            </div>
            <hr />
            <ul>
              {this.renderData()}
            </ul>
          </div>
        </div>
      </div>
    )
  }

  renderData() {
    return this.props.all_room_types.map(item => {
      return (
        <li key={item.id}>
          {item.name}
        </li>
      )
    })
  }   
}

export default BookingButtonPresenterRoomTypeOrder